const ID = 'content-media';

export default ID;
